<template>
    <div>
        <EdsTile>
            <template #title>
                <p>{{page.name}}</p>
            </template>
            <template #actions>
                <EdsTag class="action" v-if="page.name" :color="page.isPublished ? 'green' : ''">{{page.isPublished ? 'Published' : 'Draft'}}</EdsTag>
                <EdsTooltip class="action" :data="'Preview'" v-if="page.sections && page.sections.length > 0" :position="'left'">
                    <i class="icon icon-eye" @click="previewPage()"></i>
                </EdsTooltip>
                <EdsTooltip class="action" :data="'Delete'" v-if="!page.isPublished" :position="'left'">
                    <i class="icon icon-trashcan" @click="deletePage()"></i>
                </EdsTooltip>
            </template>
            <template #content>
                <TextComponent class="mb-0-5" :field-name="'Name'" v-model="page.name" :is-mandatory="true" />
                <TextComponent class="mb-0-5" :field-name="'Short name'" v-model="page.shortName" />
                <EditPageContent :sections="page.sections" @reorder="updateSections"></EditPageContent>
            </template>
            <template #bottom>
                <div class="left">
                    <button class="btn" @click="unpublishPage()" :disabled="!page.isPublished">Unpublish</button>
                </div>
                <div class="right">
                    <button class="btn" @click="publishPage()" :disabled="!page.id">Publish</button>
                    <button class="btn primary" @click="savePage()" :disabled="!isDirty">Save</button>
                </div>
            </template>
        </EdsTile>
        <ConfirmationComponent :isOpen="isOpen" confirmName="Delete" @cancel="isOpen = false" @confirm="confirmDelete">
            <div slot="header">Delete</div>
            <div slot="content">Are you sure you want to delete page {{ page.name }}?</div>
        </ConfirmationComponent>
    </div>
</template>
<script>
import TextComponent from '@/components/base.component/TextComponent.vue';
import EdsTile from '@/components/base.component/EdsTile.vue';
import EdsTooltip from '@/components/base.component/EdsTooltip.vue';
import EdsTag from '@/components/base.component/EdsTag.vue';
import EditPageContent from '@/components/complex.component/EditPageContent.vue';
import ConfirmationComponent from '@/components/base.component/ConfirmationComponent.vue';
import PageApiService from '@/services/api/pageApiService';

export default {
  props: {
    page: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
        originalPage: {},
        isDirty: true,
        isValid: false,
        isOpen: false
    }
  },
  components: {
    TextComponent,
    EdsTile,
    EdsTooltip,
    EdsTag,
    EditPageContent,
    ConfirmationComponent
  },
  mounted() {
    this.originalPage = {...this.page};
  },
  methods: {
    deletePage() {
        this.isOpen = true;
    },
    previewPage() {
        this.$emit('preview', this.page);
    },
    async savePage() {
        await PageApiService.save(this.page.id, this.page);
        this.setPublishState(false);
        this.$emit('reload');
    },
    async publishPage() {
        await PageApiService.save(this.page.id, this.page);
        await PageApiService.publish(this.page.id);
        this.setPublishState(true);
    },
    async unpublishPage() {
        await PageApiService.unpublish(this.page.id);
        this.setPublishState(false);
    },
    confirmDelete() {
        this.isOpen = false;
        this.$emit('delete', this.index);
    },
    setPublishState(isPublished) {
        this.page.isPublished = isPublished;
    },
    updateSections(sections) {
        this.page.sections = [...sections];
    }
  }
};
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';
</style>